// One GA4 page_view per route change. Mounted once inside the router; renders
// nothing. See src/lib/analytics.ts for where analytics may and may not run.
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { trackPageView } from "@/lib/analytics";
import { trackMetaPageView } from "@/lib/metaPixel";

/** Pages set their <title> in an effect, often after a lazy chunk loads; wait
 *  briefly so the report shows "Beaver County Stockyards Ticker", not the
 *  previous page's title. A quick second navigation cancels the first. */
const TITLE_SETTLE_MS = 800;

export default function AnalyticsTracker() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    const t = window.setTimeout(() => {
      trackPageView(pathname, search);
      trackMetaPageView(pathname, search);
    }, TITLE_SETTLE_MS);
    return () => window.clearTimeout(t);
  }, [pathname, search]);
  return null;
}
